import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Es la autorización para variar el contenido de una licencia urbanística expedida y vigente. ")
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", { class: "font-semibold mt-4" }, "Requisitos", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("ul", { class: "list-disc pl-6 mt-2" }, [
  /*#__PURE__*/_createElementVNode("li", null, "Nuevo plano del proyecto urbanístico o de parcelación firmado por arquitecto con matrícula profesional."),
  /*#__PURE__*/_createElementVNode("li", null, "Para parcelación: si la propuesta de modificación implica incremento en recursos naturales, aportar actualizaciones de permisos, concesiones o autorizaciones."),
  /*#__PURE__*/_createElementVNode("li", null, "Para modificación de licencias de subdivisión urbana o rural: plano que refleje la conformación de los predios antes y después de la modificación, debidamente amojonado y alineado, según normas vigentes, con su respectivo cuadro de áreas."),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createTextVNode("Para modificación de licencias de construcción: proyecto arquitectónico ajustado, que incluya como mínimo: "),
    /*#__PURE__*/_createElementVNode("ul", { class: "list-decimal pl-8 mt-1" }, [
      /*#__PURE__*/_createElementVNode("li", null, "Localización"),
      /*#__PURE__*/_createElementVNode("li", null, "Plantas"),
      /*#__PURE__*/_createElementVNode("li", null, "Alzados o cortes de la edificación relacionados con la vía pública o privada y, si aplica, inclinación real del terreno"),
      /*#__PURE__*/_createElementVNode("li", null, "Fachadas"),
      /*#__PURE__*/_createElementVNode("li", null, "Detalle de cubiertas"),
      /*#__PURE__*/_createElementVNode("li", null, "Cuadro de áreas")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("li", null, "Si la modificación implica ajustes estructurales: adjuntar memoria de cálculos y diseños estructurales, planos estructurales y especificaciones técnicas.")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h4", { class: "font-semibold mt-4" }, "Procedimiento", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "mt-2" }, " Se radica ante el curador urbano con la documentación ajustada, se realiza la revisión técnica y jurídica, y de ser aprobada se expide el acto administrativo que modifica la licencia. ", -1)

import LicenceItem from "./LicenceItem.vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LicenceItem, { title: 'Modificación de Licencia Vigente' }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _hoisted_3,
      _hoisted_4,
      _hoisted_5
    ]),
    _: 1
  }))
}
}

})